/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

// get from session storage(if the value expired it is deleted)
export function sessionget(key) {
  let stringValue = global.sessionStorage.getItem(key);
  if (stringValue) {
    let value = JSON.parse(stringValue);
    if (value.expirationTimestamp > Date.now()) {
      return value.value;
    }
    global.sessionStorage.removeItem(key);
  }
  return null;
}

// add into session storage
export function sessionset(key, value, expirationInMs = 5000) {
  global.sessionStorage.setItem(key, JSON.stringify({
    expirationTimestamp: Date.now() + expirationInMs,
    value
  }));
}

